import { delay } from "@Shared/@Utils/utils";
import { computed, defineComponent, ref } from "@vue/composition-api";
import { useI18n } from "vue-i18n-composable";
import * as AccountPlanGetters from "@Broker/@Modules/account-plan/store/account-plan-getters";
import { useAccountPlanStoreGetters } from "../../store/account-plan-helpers";
import Amplitude from "@Shared/@Utils/amplitude";
export default defineComponent({
  name: "InvoicesContainer",
  setup() {
    const {
      t
    } = useI18n();
    const {
      INVOICES
    } = useAccountPlanStoreGetters([AccountPlanGetters.INVOICES]);
    const downloading = ref("");
    const options = computed(() => ({
      filterable: false,
      sortable: ["createdAt"],
      columns: ["number", "createdAt", "total", "actions"],
      sortIcon: {
        base: "fa",
        up: "fa-sort-up",
        down: "fa-sort-down",
        is: "fa-sort"
      },
      headings: {
        number: t("application-form.number"),
        createdAt: t("global.doorr.dateCreated"),
        total: t("global.words.total"),
        actions: t("global.words.actions")
      },
      columnsClasses: {
        number: "w-20",
        createdAt: "w-20",
        total: "w-20",
        actions: " hidden-heading w-40"
      },
      skin: "table table-hover",
      perPage: 999999,
      texts: {
        noResults: t("account.accountPlan.perks.emptyInvoicesMessage")
      }
    }));
    const handleDownloadInvoice = async ({
      id
    }) => {
      downloading.value = id;
      await delay(2000);
      downloading.value = "";
      Amplitude.logEvent("Account Plan - Invoice Download Attempt Completed", {
        id
      });
    };
    const handleViewInvoice = async ({
      id
    }) => {
      Amplitude.logEvent("Account Plan - View Invoice External Page Visited", {
        id
      });
    };
    const shouldShowViewInvoiceText = invoice => invoice.paid || invoice.status === "void";
    return {
      INVOICES,
      options,
      downloading,
      handleDownloadInvoice,
      handleViewInvoice,
      shouldShowViewInvoiceText
    };
  }
});